import { DeviceInternetOfThings } from '@shure/shared/angular/data-access/system-api/models';

import { InternetOfThingsFragment } from '../graphql/generated/cloud-sys-api';

export function mapInternetOfThingsFromSysApi(
	internetOfThings: InternetOfThingsFragment | null
): DeviceInternetOfThings {
	return {
		enabled: internetOfThings?.enabled ?? false,
		connected: internetOfThings?.connected ?? false
	};
}
